import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const RadioMeta: ComponentMeta = {
  componentName: "Radio",
  package: "@mijadesign/web",
  title: "单选框",
  description: "单选框，用于从多个选项中选择一个",
  category: ComponentCategory.FORM,
  icon: "CheckCircleOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "checked",
      label: "是否选中",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "value",
      label: "值",
      type: PropType.STRING,
      group: "数据",
    },
    {
      name: "children",
      label: "文本",
      type: PropType.STRING,
      group: "内容",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
  ],
  defaultProps: {
    checked: false,
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Radio",
  },
  snippet: {
    componentName: "Radio",
    package: "@mijadesign/web",
    props: { children: "单选框" },
  },
};

export const RadioGroupMeta: ComponentMeta = {
  componentName: "Radio.Group",
  package: "@mijadesign/web",
  title: "单选组",
  description: "单选框组，用于从多个选项中选择一个",
  category: ComponentCategory.FORM,
  icon: "CheckCircleOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "value",
      label: "选中值",
      type: PropType.STRING,
      group: "数据",
    },
    {
      name: "options",
      label: "选项",
      type: PropType.JSON,
      description: '选项列表，如：[{ label: "选项1", value: "1" }]',
      group: "数据",
    },
    {
      name: "optionType",
      label: "选项类型",
      type: PropType.ENUM,
      defaultValue: "default",
      options: [
        { label: "默认", value: "default" },
        { label: "按钮", value: "button" },
      ],
      group: "样式",
    },
    {
      name: "buttonStyle",
      label: "按钮样式",
      type: PropType.ENUM,
      defaultValue: "outline",
      options: [
        { label: "描边", value: "outline" },
        { label: "填充", value: "solid" },
      ],
      group: "样式",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "middle",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "middle" },
        { label: "小", value: "small" },
      ],
      group: "样式",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
  ],
  defaultProps: {
    optionType: "default",
    size: "middle",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Radio",
  },
  snippet: {
    componentName: "Radio.Group",
    package: "@mijadesign/web",
    props: {
      options: [
        { label: "选项1", value: "1" },
        { label: "选项2", value: "2" },
      ],
    },
  },
};
